import { render, staticRenderFns } from "./patientPortalAssignNote.vue?vue&type=template&id=5fe78e9f&"
import script from "./patientPortalAssignNote.vue?vue&type=script&lang=js&"
export * from "./patientPortalAssignNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports